<template>
  <transition name="fade" mode="out-in">
    <router-view />
  </transition>
</template>

<script>
export default {
  beforeDestroy(){
    this.$store.state.playlist.showPreviewOld = false
  },
  mounted(){
    this.$store.state.playlist.showPreviewOld = true
  }
};
</script>

<style lang="scss" scoped>
</style>